const Csv : string = `
name,game1,game2,game3,game4,game5,game6,game7,game8,game9,game10,game11,game12,game13,game14,game15
Pete,0,    8,    9,    6,    8,    6,    4,    8,    8,    5,     9,     8,     9,     7,     8     
Becky,2,   8,    8,    2,    8,    7,    6,    8,    9,    8,     8,     1,     8,     11,    8
Marcia,1,  6,    9,    8,    7,    8,    8,    8,    3,    1,     0,     8,     8,     11,    5
Jimmy,9,   8,    9,    6,    2,    7,    8,    1,    7,    8,     8,     1,     4,     8,     8
Julius,8,  8,    4,    8,    8,    8,    4,    8,    8,    7,     8,     7,     2,     3,     8
Alex,9,    2,    5,    8,    3,    8,    8,    8,    3,    5,     5,     1,     8,     8,     2
Patrick,2, 3,    8,    4,    2,    8,    8,    2,    5,    7,     5,     9,     8,     7,     8
Deena,4,   6,    9,    4,    8,    7,    2,    6,    7,    8,     3,     8,     6,     3,     2
Amy,4,     8,    6,    8,    8,    9,    4,    8,    8,    1,     9,     9,     8,     7,     9
Terri,8,   8,    5,    8,    7,    8,    6,    8,    4,    9,     3,     1,     6,     9,     5
JR,8,      8,    6,    6,    8,    5,    8,    6,    8,    8,     0,     4,     9,     9,     8
Doug,8,    4,    6,    8,    3,    9,    8,    8,    5,    8,     3,     9,     6,     8,     5
Skip,1,    8,    8,    2,    3,    5,    2,    1,    8,    9,     8,     9,     2,     8,     9
Jamie,8,   4,    4,    8,    8,    8,    4,    2,    9,    7,     8,     8,     4,     5,     5
Rich,0,    3,    8,    6,    3,    7,    8,    6,    4,    7,     3,     7,     8,     7,     5
Webs,8,    2,    6,    8,    8,    8,    6,    6,    8,    8,     8,     4,     6,     5,     5
`

export default Csv
